import { MainNav } from './main-nav/MainNav'
import { NavItem } from '../../../shared/components/cards/nav-item/NavItem'
import { ProfileDrop } from './profile-drop/ProfileDrop'
import { ProfileDropItem } from './profile-drop/profile-drop-item/ProfileDropItem'
import { useWindowSize } from '../../../shared/hooks/UseWindowSize'
import { IconLogout } from '../../../shared/components/icons/IconLogout'
import { IconProfile } from '../../../shared/components/icons/IconProfile'
import { NavDrop } from './nav-drop/NavDrop'
import { NavLink, useLocation } from 'react-router-dom'
import { useAuth } from '../../../shared/hooks/UseAuth'
import { selectTariffDetails, selectUser } from '../../../store/reducers/AuthSlice'
import { useAppDispatch, useAppSelector } from '../../../store/hooks/Redux'
import { NavDropItem } from '../../../shared/components/cards/nav-drop-item/NavDropItem'
import { IconDocument } from '../../../shared/components/icons/IconDocument'
import { IconPaidResults } from '../../../shared/components/icons/IconPaidResults'
import { IconSeoPosition } from '../../../shared/components/icons/IconSeoPosition'
import { IconSeoSearch } from '../../../shared/components/icons/IconSeoSearch'
import { NavLinkItem } from '../../../shared/components/cards/nav-link-item/NavLinkItem'
import { NavCollapseItem } from '../../../shared/components/cards/nav-collapse-item/NavCollapseItem'
import { IconBarChart } from '../../../shared/components/icons/IconBarChart'
import { IconZap } from '../../../shared/components/icons/IconZap'
import { IconSpy } from '../../../shared/components/icons/IconSpy'
import { IconZapSearch } from '../../../shared/components/icons/IconZapSearch'
import { useTranslation } from 'react-i18next'
import { IconPPCCompliance } from '../../../shared/components/icons/IconPPCCompliance'
import { IconLanguageCompliance } from '../../../shared/components/icons/IconLanguageCompliance'
import { IconCrown } from '../../../shared/components/icons/IconCrown'
import React from 'react'
import { setModal } from '../../../store/reducers/AppSlice'
import { ChangePlan } from '../../../pages/main/projects/components/ChangePlan'
import { IconTeam } from '../../../shared/components/icons/IconTeam'
import { GuideButton } from './guide-button/GuideButton'
import { ViewGuard } from '../../../guards/ViewGuard'

export const Header = () => {
  const { t } = useTranslation()
  const { xs, sm, xl } = useWindowSize()
  const iconColor = '#0E63D8'
  const user = useAppSelector(selectUser)
  const tariffDetails = useAppSelector(selectTariffDetails)
  const { logout } = useAuth()
  const { pathname } = useLocation()
  const dispatch = useAppDispatch()

  return (
    <div className='flex items-center relative gap-[16px]'>
      <NavLink to={`${['editor', 'admin'].includes(user.sub_role) ? '/projects' : '/ad-reports'}`}>
        <img alt='logo' className='cursor-pointer w-[111px]' src={'/logo.svg'} />
      </NavLink>
      {xl && (
        <div className='flex-1'>
          <MainNav>
            <ViewGuard roles={['editor', 'admin']}>
              <NavLink end to='/projects'>
                {({ isActive }) => (
                  <NavItem active={isActive} size={'sm'}>
                    {t('navigation.projects')}
                  </NavItem>
                )}
              </NavLink>
            </ViewGuard>
            <NavDropItem
              active={['/ad-reports', '/organic-results', '/live-search'].includes(pathname)}
              label={t('navigation.SERPMonitoring')}
            >
              <NavLinkItem icon={<IconPaidResults />} to='/ad-reports'>
                {t('navigation.paidResults')}
              </NavLinkItem>
              <NavLinkItem icon={<IconDocument />} to='/organic-results'>
                {t('navigation.organicResults')}
              </NavLinkItem>
            </NavDropItem>
            <NavDropItem
              active={['/ppc-compliance', '/language-compliance-page'].includes(pathname)}
              label={t('navigation.nonCompliantAffiliates')}
            >
              <NavLinkItem icon={<IconPPCCompliance />} to='/ppc-compliance'>
                {t('navigation.PPCCompliance')}
              </NavLinkItem>
              <NavLinkItem icon={<IconLanguageCompliance />} to='/language-compliance-page'>
                {t('navigation.nonCompliantContent')}
              </NavLinkItem>
            </NavDropItem>
            <NavDropItem
              active={['/position-tracker', '/serp-presence', '/advertising-research'].includes(
                pathname,
              )}
              label={t('navigation.researchTools')}
            >
              <NavLinkItem icon={<IconSeoPosition />} to='/position-tracker'>
                {t('navigation.SEOPositionTracker')}
              </NavLinkItem>
              <NavLinkItem icon={<IconBarChart />} to='/serp-presence'>
                {t('navigation.onSiteBrandMentions')}
              </NavLinkItem>
              <NavLinkItem icon={<IconSeoSearch />} to='/advertising-research'>
                {t('navigation.advertisingResearch')}
              </NavLinkItem>
            </NavDropItem>
            <NavDropItem
              active={['/live-uncloaking', '/blackhat-monitoring'].includes(pathname)}
              hidden={!user.allow_decloak_live && !user.allow_decloak_auto}
              label={t('navigation.uncloaking')}
            >
              <NavLinkItem
                hidden={!user.allow_decloak_live}
                icon={<IconZap />}
                to='/live-uncloaking'
              >
                {t('navigation.liveUncloaking')}
              </NavLinkItem>
              <NavLinkItem
                hidden={!user.allow_decloak_auto}
                icon={<IconSpy />}
                to='/blackhat-monitoring'
              >
                {t('navigation.blackhatMonitoring')}
              </NavLinkItem>
            </NavDropItem>
          </MainNav>
        </div>
      )}

      <div className='ml-auto flex justify-end gap-[16px] w-[calc(100%-127px)] md:w-auto'>
        <ViewGuard roles={['editor', 'admin']}>
          {tariffDetails?.tariff && (
            <button
              onClick={() =>
                dispatch(
                  setModal({
                    children: (
                      <ChangePlan
                        step={
                          tariffDetails.tariff?.is_subscription_expired
                            ? 'change-plan'
                            : 'show-info'
                        }
                      />
                    ),
                  }),
                )
              }
            >
              <div
                className={`rounded-full
                  h-[38px]
                  gap-[6px]
                  w-[38px]
                  flex
                  items-center
                  justify-center
                  md:px-[12px]
                  md:w-auto
                  md:h-[32px]
                  ${tariffDetails.tariff.is_subscription_expired ? 'bg-[#FF4980]' : 'bg-white'}
                `}
              >
                <IconCrown
                  className='w-[16px]'
                  color={tariffDetails.tariff.is_subscription_expired ? '#FFFFFF' : '#A059FF'}
                />
                <span
                  className={`font-medium whitespace-nowrap hidden md:block ${
                    tariffDetails.tariff.is_subscription_expired ? 'text-white' : 'text-default'
                  }`}
                >
                  {tariffDetails.tariff.is_subscription_expired
                    ? t('pages.tariff.planExpired')
                    : tariffDetails.tariff.type === 'custom'
                    ? t('pages.tariff.customPlan')
                    : tariffDetails.tariff.name}
                </span>
              </div>
            </button>
          )}
        </ViewGuard>
        <GuideButton />
        <ProfileDrop>
          <NavLink to='/profile-settings'>
            <ProfileDropItem icon={<IconProfile color={iconColor}></IconProfile>}>
              {t('pages.profile.profile')}
            </ProfileDropItem>
          </NavLink>
          <ViewGuard roles={['admin']}>
            <NavLink to='/team'>
              <ProfileDropItem icon={<IconTeam color={iconColor}></IconTeam>}>
                {t('pages.profile.team')}
              </ProfileDropItem>
            </NavLink>
          </ViewGuard>
          <ProfileDropItem
            icon={<IconLogout color={iconColor}></IconLogout>}
            onClick={() => logout()}
          >
            {t('pages.profile.logout')}
          </ProfileDropItem>
        </ProfileDrop>
        {!xl && (
          <div className='z-10'>
            <NavDrop>
              <ViewGuard roles={['editor', 'admin']}>
                <NavLink end to='/projects'>
                  {({ isActive }) => (
                    <NavItem active={isActive} decoration='dot' size='md' theme='dark'>
                      {t('navigation.projects')}
                    </NavItem>
                  )}
                </NavLink>
              </ViewGuard>
              <NavCollapseItem
                active={['/ad-reports', '/organic-results', '/live-search'].includes(pathname)}
                decoration='dot'
                label={t('navigation.SERPMonitoring')}
                size='sm'
                theme='dark'
              >
                <NavLinkItem icon={<IconPaidResults />} to='/ad-reports'>
                  {t('navigation.paidResults')}
                </NavLinkItem>
                <NavLinkItem icon={<IconDocument />} to='/organic-results'>
                  {t('navigation.organicResults')}
                </NavLinkItem>
              </NavCollapseItem>
              <NavCollapseItem
                active={['/ppc-compliance', '/language-compliance-page'].includes(pathname)}
                decoration='dot'
                label={t('navigation.nonCompliantAffiliates')}
                size='sm'
                theme='dark'
              >
                <NavLinkItem icon={<IconPPCCompliance />} to='/ppc-compliance'>
                  {t('navigation.PPCCompliance')}
                </NavLinkItem>
                <NavLinkItem icon={<IconLanguageCompliance />} to='/language-compliance-page'>
                  {t('navigation.nonCompliantContent')}
                </NavLinkItem>
              </NavCollapseItem>
              <NavCollapseItem
                active={['/position-tracker', '/serp-presence', '/advertising-research'].includes(
                  pathname,
                )}
                decoration='dot'
                label={t('navigation.researchTools')}
                size='sm'
                theme='dark'
              >
                <NavLinkItem icon={<IconSeoPosition />} to='/position-tracker'>
                  {t('navigation.SEOPositionTracker')}
                </NavLinkItem>
                <NavLinkItem icon={<IconBarChart />} to='/serp-presence'>
                  {t('navigation.onSiteBrandMentions')}
                </NavLinkItem>
                <NavLinkItem icon={<IconSeoSearch />} to='/advertising-research'>
                  {t('navigation.advertisingResearch')}
                </NavLinkItem>
              </NavCollapseItem>
              <NavCollapseItem
                active={['/live-uncloaking', '/blackhat-monitoring'].includes(pathname)}
                decoration='dot'
                label={t('navigation.uncloaking')}
                size='sm'
                theme='dark'
              >
                <NavLinkItem icon={<IconZap />} to='/live-uncloaking'>
                  {t('navigation.liveUncloaking')}
                </NavLinkItem>
                <NavLinkItem icon={<IconSpy />} to='/blackhat-monitoring'>
                  {t('navigation.blackhatMonitoring')}
                </NavLinkItem>
              </NavCollapseItem>
            </NavDrop>
          </div>
        )}
      </div>
    </div>
  )
}
